import { render } from "./artigoForm.vue?vue&type=template&id=586c42f4&scoped=true"
import script from "./artigoForm.vue?vue&type=script&lang=js"
export * from "./artigoForm.vue?vue&type=script&lang=js"

import "./artigoForm.vue?vue&type=style&index=0&id=586c42f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586c42f4"]])

export default __exports__